(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lbe-product-help"] && !Shopify.designMode) return;
  try {
    function lbeBindSticky() {
  const bar = document.querySelector('.lbe-sticky-buy');
  const nativeButton = document.querySelector('product-info product-form button[name="add"]');
  if (!bar || !nativeButton || bar.dataset.bound) return;
  bar.dataset.bound = 'true';
  const button = bar.querySelector('button');
  const sync = () => {
    const passedButton = nativeButton.getBoundingClientRect().bottom < 0;
    const overlayOpen = document.querySelector('cart-drawer.active, details.menu-opening, details[open] .search-modal, dialog[open]');
    bar.hidden = !passedButton || Boolean(overlayOpen);
    if (button.dataset.chooseOptions !== 'true') {
      button.disabled = nativeButton.disabled;
      button.textContent = nativeButton.querySelector('span')?.textContent.trim() || nativeButton.textContent.trim();
    }
  };
  button.addEventListener('click', () => {
    if (button.dataset.chooseOptions !== 'true') {
      if (!nativeButton.disabled) nativeButton.click();
      return;
    }
    const picker = document.querySelector('product-info variant-selects');
    const target = picker || nativeButton;
    target.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center'});
    const control = picker?.querySelector('input:checked, select') || nativeButton;
    control.focus({preventScroll:true});
  });
  new MutationObserver(sync).observe(document.body, {attributes:true,subtree:true,attributeFilter:['open','class']});
  new MutationObserver(sync).observe(nativeButton, {attributes:true,childList:true,subtree:true,characterData:true});
  let scrollQueued = false;
  const scheduleSync = () => {
    if (scrollQueued) return;
    scrollQueued = true;
    requestAnimationFrame(() => {
      scrollQueued = false;
      sync();
    });
  };
  window.addEventListener('scroll', scheduleSync, {passive:true});
  window.addEventListener('resize', scheduleSync);
  sync();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',lbeBindSticky); else lbeBindSticky();
document.addEventListener('shopify:section:load',lbeBindSticky);
  } catch(e) { console.error(e); }
})();

})();
